/**
 * Less Global variables that are injected on
 * top of every less file.
 */
const LessGlobals = Object.freeze({
	badge: {
		'min-width': '50px'
	},
	color: {
		black: {
			10: 'rgba(0, 0, 0, 0.1)',
			12: 'rgba(0, 0, 0, 0.12)',
			50: 'rgba(0, 0, 0, 0.5)',
			100: 'rgba(0, 0, 0, 1)'
		},
		gray: {
			22: '#222222',
			66: '#666666',
			75: '#757575',
			90: '#909090',
			a0: '#a0a0a0',
			cc: '#cccccc',
			c0: '#c0c0c0',
			eb: '#ebebeb',
			fa: '#fafafa',
			f0: '#f0f0f0'
		},
		red: {
			base: '#cc0000',
			dark: '#a00000'
		},
		white: '#ffffff'
	},
	height: '56px',
	media: {
		desktop: '~"all and (min-width: 600px)"'
	},
	padding: '16px',
	'z-index': 9000,
	'z-index-step': 1
});

/**
 * Parse less string, remove ~"" from string.
 */
function parseLessString(str) {
	return str.replace(/~"(.*)"/, '$1');
}

module.exports = { LessGlobals, parseLessString };
